export default {"src":"/_next/static/media/first.145235af.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};